import { render, staticRenderFns } from "./IviewCheckbox.vue?vue&type=template&id=3e0c8b23&scoped=true&"
import script from "./IviewCheckbox.vue?vue&type=script&lang=js&"
export * from "./IviewCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./IviewCheckbox.vue?vue&type=style&index=0&id=3e0c8b23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c8b23",
  null
  
)

export default component.exports